import { FC } from 'react'
import styled from 'styled-components'
import { colors } from 'shared/lib'

const TextDividerBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
`

const Text = styled.div`
  text-transform: uppercase;
  color: ${colors.FC2_GREY};
  margin: 0 10px;
`

const Divider = styled.div`
  flex-grow: 1;
  border-bottom: 1px solid ${colors.FC2_LIGHTEST_GREY};
`

interface ITextDividerProps {
  qaAttr?: string
  className?: string
}

const TextDivider: FC<ITextDividerProps> = ({ children, className, qaAttr }) => {
  return (
    <TextDividerBox className={className}>
      <Divider />
      <Text data-qa={qaAttr}>{children}</Text>
      <Divider />
    </TextDividerBox>
  )
}

export default TextDivider
